[
	"hinge",
	"log",
	"modifiedHuber",
	"perceptron",
	"squaredHinge"
]
